export const tableData = (data) => {
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "observacion",
      headerName: "Observacion",
      flex: 4,
      minWidth: 400,
    },
    {
      field: "fecha_incidencia",
      headerName: "Fecha Incidencia",
      flex: 1,
      minWidth: 200,
    },
    /* {
      field: "user_id",
      headerName: "User ID", // (cambiar por nombre persona?)
      minWidth: 100,
    }, */
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      observacion: d.observacion,
      fecha_incidencia: d.fecha_incidencia,
      // user_id: d.user_id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      String(d.observacion)?.toString().toLowerCase().includes(value) ||
      String(d.fecha_incidencia)?.toString().toLowerCase().includes(value) ||
      String(d.user_id)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
